<div *ngIf="enrollmentPeriodActive" class="spacing">Click Add Resident to add new residents to the roster. A prompt will appear to search 
  existing AAOS residents before adding a new one. Click the ellipsis menu to the right of each resident for a list of
  additional options including entering transition information. <strong>Please note the PGY level will be updated on July 1<sup>st</sup> in the new academic year.</strong>
</div>
<div *ngIf="!enrollmentPeriodActive" class="spacing">During the enrollment period, options will be available on this page to add residents to the roster, remove residents, maintain resident information, and enter transition information as residents near the end of their residency. 
</div>
<div class="spacing">
  <div *ngIf="!loading" class="small-bottom-margin">Total Residents = {{ residentCount }}</div>
  <div class="small-bottom-margin">
  <mat-select [(value)]="selectedYear" class="width--25 small--font" placeholder="Filter by PGY"
    (selectionChange)="applyFilter(selectedYear)" disableRipple panelClass="mat-panel">
    <mat-option [value]="">Show All</mat-option>
    <mat-option [value]="1">1 </mat-option>
    <mat-option [value]="2">2 </mat-option>
    <mat-option [value]="3">3 </mat-option>
    <mat-option [value]="4">4 </mat-option>
    <mat-option [value]="5">5 </mat-option>
  </mat-select>

  <button *ngIf="enrollmentPeriodActive" class="btn btn--right btn--solid btn--red" [disabled]="!editPrivileges"  (click)="openSearchDialog()">Add
    Resident</button>
  </div>

  <table class="mat-elevation-z8" matSort mat-table matSortActive="residencyPostGraduateYear" matSortDirection="asc" [dataSource]="dataSource">
    <ng-container matColumnDef="residencyPostGraduateYear">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Year </th>
      <td mat-cell class="roster-table-top-padding" *matCellDef="let resident">
        <span [ngClass]="{'roster-table-number-one': resident.residencyPostGraduateYear ==='1', 
          'roster-table-number-two': resident.residencyPostGraduateYear ==='2', 
          'roster-table-number-three': resident.residencyPostGraduateYear ==='3',
          'roster-table-number-four': resident.residencyPostGraduateYear ==='4',
          'roster-table-number-five': resident.residencyPostGraduateYear ==='5'}"></span>
      </td>
    </ng-container>
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
      <td mat-cell *matCellDef="let resident"> {{resident.firstName}} </td>
    </ng-container>
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
      <td mat-cell *matCellDef="let resident"> {{resident.lastName}} </td>
    </ng-container>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer ID </th>
      <td mat-cell *matCellDef="let resident"> {{ trimLeadingZeros(resident.id) }} </td>
    </ng-container>
    <ng-container matColumnDef="institutionalEmail">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let resident"> {{resident.institutionalEmailAddress}} </td>
    </ng-container>
    <ng-container matColumnDef="residencyDates">
      <th mat-header-cell *matHeaderCellDef> Dates of Residency </th>
      <td mat-cell *matCellDef="let resident"> {{resident.residencyBeginDate | date: 'MMMM d, yyyy'}} to
        {{resident.residencyEndDate | date: 'MMMM d, yyyy'}}</td>
    </ng-container>
    <ng-container matColumnDef="npi">
      <th mat-header-cell *matHeaderCellDef> NPI </th>
      <td mat-cell *matCellDef="let resident"> {{resident.npi}} </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let resident">
        <div *ngIf="enrollmentPeriodActive || resident.canEditTransition">
        <div class="roster-table-horiztonal-ellipsis" [matMenuTriggerFor]="menu"></div>
        <mat-menu #menu="matMenu" yPosition="below" xPosition="after">
          <button mat-menu-item [disabled]="!editPrivileges || !enrollmentPeriodActive || resident.isTransitioned" 
            (click)="openEditResidentDialog(resident)">Edit...</button>
          <button mat-menu-item [disabled]="!editPrivileges || !resident.canEditTransition" 
            *ngIf="resident.residencyPostGraduateYear === '5' && !resident.isTransitioned" 
            (click)="openTransitionResidentDialog(resident)">Transition...</button>
          <button mat-menu-item [disabled]="resident.isTransitioned" 
            *ngIf="resident.isTransitioned" >Completed</button>
          <button mat-menu-item [disabled]="!editPrivileges || !enrollmentPeriodActive || resident.isTransitioned || resident.residencyPostGraduateYear === '5'"
            (click)="openRemoveResidentDialog(resident)">Remove</button>
        </mat-menu>
      </div>

      </td>

    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>

  </table>
</div>
<aaos-spinner [isLoading]="loading"></aaos-spinner>
